//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"CornerRadius",0,"Expression",0],[1,"CutoutDepth",0,"Expression",0],[0,"DepthType",1,0],[0,"FilletSectionCorners",1,0],[0,"IncludeRounding",1,0],[1,"MinimumToolClearance",0,"Expression",0],[1,"RadiusOfDie",0,"Expression",0],[0,"Section",1,"Section",0],[0,"SectionSide",1,0],[1,"SideAngle",0,"Expression",0],[0,"SidewallType",1,0],[0,"Sketch",1,"Features.SketchFeature",0]],[[[],"ValidateBuilderData",{R_:{builder_data_validity:''}},0,0]],[]];
SPLM.Features.SheetMetal.DrawnCutoutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.DrawnCutoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.DrawnCutoutBuilder.DepthTypeOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.DrawnCutoutBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.DrawnCutoutBuilder.SidewallTypeOptions = Object.freeze({
    "Outside" : "Outside", "Inside" : "Inside"});

export default SPLM;